<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Post Requirement</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container-filud">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-9">
            <div class="isotope-wrapper">
              <div class="box_general padding_bottom">
                <div class="header_box version_2">
                  <h3>
                    <i class="fa fa-phone"></i> Receive Quotation from merchant
                    (user/tourist can see quotes by merchants and contact
                    merchants by visiting their profile)
                  </h3>
                </div>
                <form @submit.prevent="createrequirent()">
                  <div class="row">
                    <div class="col-md-12 add_top_30">
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="category"
                              >Occasion<sup style="color: red">*</sup></label
                            >
                            <select
                              name=""
                              class="form-control select2"
                              id="category"
                              required
                              v-model="event"
                            >
                              <option value="">-Select-</option>
                              <option value="birthday">BirthDay</option>
                              <option value="anniversary">Anniversary</option>
                              <option value="party">Party</option>
                              <option value="engagement">Engagement</option>
                              <option value="baby-shower">Baby-shower</option>
                              <option value="farewell">Farewell</option>
                              <option value="retirement">Retirement</option>
                              <option value="others">Others</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label
                              >Event Date<sup style="color: red">*</sup></label
                            >
                            <date-picker
                              v-model="event_date"
                              required
                              :config="datepickerconfig2"
                            ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label
                              >Requirement Expire Date<sup style="color: red"
                                >*</sup
                              ></label
                            >
                            <date-picker
                              v-model="event_end"
                              :config="datepickerconfig"
                              required
                            ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <label
                              >Short Description<sup style="color: red"
                                >*</sup
                              ></label
                            >
                            <textarea
                              cols="3"
                              rows="8"
                              class="form-control"
                              v-model="short_description"
                            ></textarea>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <label
                              >Description<sup style="color: red">*</sup></label
                            >
                            <ckeditor
                              :editor="editor"
                              v-model="description"
                              :config="editorConfig"
                            ></ckeditor>
                          </div>
                        </div>
                      </div>
                      <!-- /row-->
                      <div class="row">
                        <div class="col-lg-6">
                          <label
                            >Categories<sup style="color: red">*</sup></label
                          >
                          <select2-multiple-control
                            :options="catOptions"
                            :settings="{
                              multiple: true,
                            }"
                            multiple
                            @select="catSelectEvent($event)"
                          />
                        </div>

                        <div class="col-lg-6">
                          <label
                            >Sub Categories<sup style="color: red"
                              >*</sup
                            ></label
                          >
                          <select2-multiple-control
                            :options="subCatOptions"
                            :settings="{ multiple: true }"
                            @select="subcatselectEvent($event)"
                            placeholder="-Select Categories-"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6">
                          <label>Location<sup style="color: red">*</sup></label>
                          <vue-simple-suggest
                            v-model="location"
                            display-attribute="name"
                            value-attribute="url"
                            :list="getSuggestionList"
                            @select="get($event)"
                          ></vue-simple-suggest>
                        </div>
                        <div class="col-lg-6">
                          <label>Pincode<sup style="color: red">*</sup></label>
                          <input
                            class="form-control"
                            required
                            type="number"
                            v-model="pincode"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-12">
                          <label>Files</label>
                          <input
                            class="form-control"
                            type="file"
                            @change="onFileChange"
                          />
                        </div>
                      </div>
                      <!-- /row-->
                      <div class="row">
                        <div class="col-md-12">
                          <div id="pass-info" class="clearfix"></div>
                          <center>
                            <button
                              type="submit"
                              class="btn_1 rounded add_top_30 mb-4"
                            >
                              Post Requirement
                            </button>
                          </center>
                        </div>
                      </div>
                      <!-- /row-->
                    </div>
                  </div>
                </form>
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>
      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
// import axios from 'axios'
import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import moment from "moment";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select2MultipleControl from "v-select2-multiple-component";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
export default {
  data() {
    return {
      search: {
        categories: [],
        subcategories: [],
      },
      catOptions: [],
      subCatOptions: [],
      roleId: localStorage.getItem("role_id"),
      token: "Bearer " + localStorage.getItem("token"),

      category_id: [],
      msg: null,
      classAlert: null,
      profile_img: null,
      image: "",
      location: "",
      pincode: "",
      datepickerconfig2: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        minDate: new Date(),
      },
      datepickerconfig: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        minDate: new Date(),
        maxDate: new Date().setMonth(new Date().getMonth() + 1),
      },
      description: "",
      short_description: "",
      event_end: this.frontEndDateFormat(
        new Date(new Date().setDate(new Date().getDate() + 7))
      ),
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
        height: "800px",
      },
      event_date: "",
      event: "",
      file: null,
      geocodes:[]
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
    Select2MultipleControl,
    VueSimpleSuggest,
  },
  beforeMount() {
    this.checkToken();
    this.getParentCategories();
    this.getAreaofinterest();
  },

  methods: {
    checkToken() {
      //alert(this.token);
      if (this.token == "Bearer " + null) {
        this.$router.push("/signin");
      }
    },
    get(value) {
      var i = [];
      API.get(`https://location.securebrandtech.com/auto/api?q=${value}`)
        .then(function (response) {
         var j =0 ;
          response.data.features.forEach(function (feature) {
            if(j === 0){
            i.push(feature.geometry.coordinates);
            }
           j++;
          });
        })
        .catch(function (error) {
          console.log(error);
        });
      setTimeout(() => {
        this.geocodes = i;
      }, 2000);
    }, 
    getSuggestionList() {
      var i = [];
      if (this.location.length >= 2) {
        return API.get(
          `https://location.securebrandtech.com/auto/api?q=${this.location}`
        )
          .then(function (response) {
            response.data.features.forEach(function (feature) {
              i.push(
                feature.properties.name +
                  " " +
                  feature.properties.county +
                  " " +
                  " " +
                  feature.properties.state +
                  " " +
                  feature.properties.postcode
              );
            });
            var uniq = [...new Set(i)];
            return uniq;
          })

          .catch(function (error) {
            console.log(error);
          });
      }
    },
    getParentCategories() {
      API.get("categories/parent_services_select2list")
        //.get("categories/parent_services")
        .then((res) => {
          this.catOptions = res.data.data;
          // this.search = this.search.categories;
          console.log(res.data.data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    setSubCategory(categoryId, mode) {
      //alert(categoryId);
      let selSubCat = this.search.subcategories;
      API.get(
        "categories/parent_services_select2list/" + window.btoa(categoryId)
      )
        //.get("categories/parent_services")
        .then((res) => {
          if (mode == "push") {
            res.data.data.forEach((val) => {
              console.log("val=" + JSON.stringify(val));
              this.subCatOptions.push(val);
              //this.subCatOptions.concat(res.data.data);
            });

            //console.log("sub cat options=" + this.subCatOptions);
          } else {
            //this.search.subcategories.push(res.data.data);
            res.data.data.forEach((val) => {
              this.subCatOptions.splice(this.subCatOptions.indexOf(val.id), 1);
            });
          }
          this.search.subcategories = selSubCat;
          // this.emitFilterRequest();
          //this.loadNearbyOffers(this.search);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    catSelectEvent(e) {
      var sel = e.selected;
      if (sel) {
        this.setSubCategory(e.id, "push");
        this.search.categories.push(e.id);
      } else {
        this.setSubCategory(e.id, "remove");
        this.search.categories.splice(this.search.categories.indexOf(e.id), 1);
      }
    },
    subcatselectEvent(e) {
      var sel = e.selected;
      //alert(sel + " " + e.id + " " + e.text + " " + e.selected);
      if (sel) {
        this.search.subcategories.push(e.id);
      } else {
        this.search.subcategories.splice(
          this.search.subcategories.indexOf(e.id),
          1
        );
      }
      //this.loadNearbyOffers(this.search);
    },

    getAreaofinterest() {
      const token = "Bearer " + localStorage.getItem("token");
      // alert(token);

      API.get("customer/category_by_customerId", {
        headers: { Authorization: token },
      })
        .then((res) => {
          this.categories = res.data.data;
          // res.data.data.forEach((value) => {
          //   // this.category_id.push(value.tag_id);
          // });
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    frontEndDateFormat(date) {
      //alert(moment(date, "YYYY-MM-DD").format("DD-MM-YYYY"));
      return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
    },
    backEndDateFormat: function (date) {
      return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    },

    createrequirent() {
        const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
       if(this.geocodes.length == 0){
         Toast.fire({
          icon: "Error",
          title: "Please Select Location List Option ",
        });
        this.loading = false;
        return false;
      }
      this.category_id.push(this.search.categories);
      this.category_id.push(this.search.subcategories);
      const form = new FormData();
      form.append("category_id[]", this.category_id);
      form.append("location", this.location);
      form.append("pincode", this.pincode);
      form.append("event_date", this.event_date);
      form.append("event_end", this.event_end);
      form.append("description", this.description);
      form.append("short_description", this.short_description);
      form.append("event", this.event);
      form.append("file", this.file);
      form.append("lat", this.geocodes);
      API.post("/Postrequirement/postcreate", form, {
        headers: { Authorization: this.token },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.msg = "Your Requirement Successfully";
            this.classAlert = "success";
            this.$router.push("/requirement-list");
            this.category_id = [];
          } else {
            this.msg = res.data.messages;
            this.classAlert = "danger";
            this.category_id = [];
          }
        })
        .catch((err) => {
          this.msg = err;
          this.classAlert = "danger";
        });
      //axios
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.file = files[0];
    },
    createImage(file) {
      this.image = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function () {
      this.image = "";
    },
  },
};
</script>
<style>
.ck-blurred, .ck-focused { height: 250px !important; }
</style>
<style  scoped>
@import "../../public/frontend/vendor/dropzone.css";

.show_img,
.header_box img {
  width: 100px;
  height: 100px;
}
</style>